export class Icon {
  constructor(public iconName: string, public iconSvg: string) {}
}


